// src/hooks/useDraftSubmission.js

import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase"; // Ensure correct import of Firestore instance

const useDraftSubmission = (submissionId) => {
  const [draftData, setDraftData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!submissionId) {
      console.log("Missing submissionId"); // Debugging log
      setDraftData(null);
      setLoading(false);
      return;
    }

    // Reference to the specific draft document
    const draftDocRef = doc(db, "submissions", submissionId);

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      draftDocRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          // console.log("Draft data found:", docSnapshot.data()); 
          setDraftData({ id: docSnapshot.id, ...docSnapshot.data() });
          setError(null); // Clear any previous errors
        } else {
          console.log("No matching draft found"); // Debugging log
          setDraftData(null);
          setError("Submission not found.");
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching draft submission:", err); // Debugging log
        setError("Failed to fetch submission.");
        setLoading(false);
      }
    );

    // Cleanup listener on unmount or when submissionId changes
    return () => unsubscribe();
  }, [submissionId]);

  return { draftData, loading, error };
};

export default useDraftSubmission;
